import Vue from "vue";
import { Component, Model } from "vue-property-decorator";
import moment, { Moment } from "moment";

@Component({
    name: "timeline",
})

export default class TimeLine extends Vue {
    @Model("input", { required: true })
    public selectedDate: Moment;

    public internalSelectedDate: Moment;

    private indexWeek: number = 0;

    public constructor() {
        super();

        this.internalSelectedDate = this.selectedDate;
    }

    public created(): void {
        if (!this.internalSelectedDate.isValid()) {
            this.internalSelectedDate = moment();
        }

        if (this.internalSelectedDate.date() !== moment().date()) {
            const daysBetween = moment.duration(this.internalSelectedDate.diff(moment().hour(0).minute(0).second(0).millisecond(0))).asDays();

            this.indexWeek = Math.floor(daysBetween / 5);
        }
    }

    public get showPrevious(): boolean {
        return this.indexWeek !== 0;
    }

    public get dates(): Moment[] {
        const arrayDates = [];
        for (let i = 0; i < 5; i++) {
            arrayDates.push(moment().add(i + 5 * this.indexWeek, "days"));
        }
        return arrayDates;
    }

    public isActive(date: Moment): boolean {
        if (date == null) {
            return moment().date() === this.internalSelectedDate.date();
        } else {
            return date.date() === this.internalSelectedDate.date();
        }
    }

    public nextWeek(): void {
        document.getElementById("btn-today").classList.remove("active");
        const buttonActive = document.querySelector(".days button.active");

        if (buttonActive !== null) {
            buttonActive.classList.remove("active");
        }
        this.indexWeek++;
    }

    public previousWeek(): void {
        const buttonActive = document.querySelector(".days button.active");

        if (buttonActive != null) {
            buttonActive.classList.remove("active");
        }

        if (this.indexWeek !== 0) {
            this.indexWeek--;
        }
    }

    public switchDate(date: Moment, index: number) {
        if (this.indexWeek === 0 && index === 0) {
            document.getElementById("btn-today").classList.add("active");
        } else {
            document.getElementById("btn-today").classList.remove("active");
        }

        const buttonActive = document.querySelector(".days button.active");

        if (buttonActive != null) {
            buttonActive.classList.remove("active");
        }

        document.querySelectorAll(".days button")[index].classList.add("active");
        this.internalSelectedDate = date;

        this.sendDate();
    }

    public goToToday(): void {
        this.indexWeek = 0;

        document.getElementById("btn-today").classList.add("active");

        const active = document.querySelector(".days button.active");

        if (active != null) {
            active.classList.remove("active");
        }

        document.querySelectorAll(".days button")[0].classList.add("active");
        this.internalSelectedDate = moment();

        this.sendDate();
    }

    public sendDate() {
        this.$emit("input", this.internalSelectedDate);
    }
}
